export const useInputStyles = {
    inputField: { width: "100%" },
    largeField: { minWidth: "360px" }
};
